import apiClient from '@/lib/api-client';
import type { WaitlistEntry, WaitlistEntryAdmin } from '@/types/booking';

interface ApiEnvelope<T> {
  data: T;
}

class WaitlistService {
  // Guest endpoints — authenticated by `guest_token` in the URL.
  async getByToken(token: string): Promise<WaitlistEntry> {
    const { data } = await apiClient.get<ApiEnvelope<WaitlistEntry>>(`/v1/waitlist_entries/${token}`);
    return data.data;
  }

  async leaveByToken(token: string, reason?: string): Promise<WaitlistEntry> {
    const { data } = await apiClient.delete<ApiEnvelope<WaitlistEntry>>(`/v1/waitlist_entries/${token}`, {
      params: reason ? { reason } : undefined,
    });
    return data.data;
  }

  // Admin endpoints — require auth.
  async adminListBySlot(availableSlotId: number): Promise<WaitlistEntryAdmin[]> {
    const { data } = await apiClient.get<ApiEnvelope<WaitlistEntryAdmin[]>>(
      `/v1/admin/available_slots/${availableSlotId}/waitlist_entries`,
    );
    return data.data;
  }

  async adminRemove(entryId: number, reason?: string): Promise<WaitlistEntryAdmin> {
    const { data } = await apiClient.delete<ApiEnvelope<WaitlistEntryAdmin>>(`/v1/admin/waitlist_entries/${entryId}`, {
      params: reason ? { reason } : undefined,
    });
    return data.data;
  }
}

export const waitlistService = new WaitlistService();
